const faqs = [
  {
    q: '黑料网下载需要注册登录吗？',
    a: '不需要。黑料网下载完全免费且无需注册登录，打开浏览器即可直接观看所有黑料视频在线播放内容，保护您的隐私安全。',
  },
  {
    q: '黑料网在线观看支持哪些设备？',
    a: '黑料网下载支持所有主流设备，包括Windows/Mac电脑、iPhone/Android手机、iPad等平板设备。无需安装APP，通过浏览器即可访问黑料在线观看全部内容。',
  },
  {
    q: '黑料视频在线播放的画质如何？',
    a: '平台提供高清画质的黑料视频在线播放服务，大部分视频支持1080P清晰度。播放流畅不卡顿，自动适配您的网络环境选择最佳画质。',
  },
  {
    q: '黑料在线看片需要下载播放器吗？',
    a: '完全不需要。黑料在线看片直接使用浏览器内置播放器，无需额外下载任何播放软件或插件。即点即看，方便快捷。',
  },
  {
    q: '网站内容多久更新一次？',
    a: '黑料网下载内容每日持续更新，编辑团队7x24小时追踪全网热点，第一时间将最新黑料视频在线观看资源上线。通常重大事件发生后30分钟内即可看到相关内容。',
  },
  {
    q: '如何向黑料网投稿爆料？',
    a: '您可以通过网站"投稿爆料"板块留下的联系方式向我们提供线索。黑料网下载重视每一条用户投稿，重要爆料一经核实将优先处理和发布。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-3">
            <i className="ri-question-answer-line"></i>
            常见问题
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            常见问答
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2">
            关于黑料网下载的常见问题解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="space-y-3 md:space-y-4">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="bg-background-50 border border-secondary-200/60 rounded-xl overflow-hidden"
              >
                <div className="p-4 md:p-5 flex items-start gap-3">
                  <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-primary-100 shrink-0 mt-0.5">
                    <span className="text-xs font-bold text-primary-600">Q</span>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-sm md:text-base font-heading font-bold text-foreground-800 mb-2">
                      {faq.q}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}